import { Injectable } from '@angular/core';

import { AsyncJobType } from '@recruitee/account-data';
import { NotificationStyle } from '@recruitee/user-interface';

import { AsyncJobConfig } from '../../async-job-view.types';

@Injectable()
export class BulkContainersDeleteAsyncJob implements AsyncJobConfig {
  public readonly type = AsyncJobType.BulkContainersDelete;
  public readonly showDialog = false;
  public readonly showNotification = true;
  public translations = {
    title: {
      success: 'app.async_jobs.bulk_containers_delete_atc.title.success',
      progress: 'app.async_jobs.bulk_containers_delete_atc.title.progress',
    },
  };

  public readonly skipNotificationMessages = true;
  public readonly skipProgressBar = false;
  public readonly workingNotificationStyle = NotificationStyle.InProgress;
}
